import { render, staticRenderFns } from "./headerItem.vue?vue&type=template&id=93ddb06a&scoped=true"
import script from "./headerItem.vue?vue&type=script&lang=js"
export * from "./headerItem.vue?vue&type=script&lang=js"
import style0 from "./headerItem.vue?vue&type=style&index=0&id=93ddb06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ddb06a",
  null
  
)

export default component.exports